







import { defineComponent } from '@vue/composition-api'
export default defineComponent({
  props: {
    icon: {
      type: String,
      default: 'https://dpubstatic.udache.com/static/dpubimg/1862d48a-94d4-4d61-a66e-46e83a4b7236.png'
    },
    text: {
      type: String,
      default: '不好意思，系统开小差了'
    }
  }
})
